// i18next setup — kiosk copy of the customer-web pattern (spec 65 +
// ADR-006), trimmed for a fixed-locale device:
//
//   * SUPPORTED_LOCALES / DEFAULT_LOCALE come from @novemai/i18n-sdk so a
//     locale registration in the SDK propagates here automatically.
//   * A kiosk is a shared shop-floor terminal, not a personal browser —
//     browser-preference detection is meaningless. Bootstrap supplies the
//     device-config locale; tr-TR is the honest fallback while config is
//     unavailable.
//   * en-US stays the SDK source/fallback locale (missing-key fallback).

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { DEFAULT_LOCALE, SUPPORTED_LOCALES, type LocaleCode } from "@novemai/i18n-sdk";

import enUS from "./locales/en-US.json";
import trTR from "./locales/tr-TR.json";

export { DEFAULT_LOCALE, SUPPORTED_LOCALES };
export type { LocaleCode };

/** Device-config fallback for an unprovisioned/unavailable terminal. */
export const KIOSK_DEFAULT_LOCALE: LocaleCode = "tr-TR";

export async function initI18n(locale: LocaleCode = KIOSK_DEFAULT_LOCALE): Promise<typeof i18n> {
  if (i18n.isInitialized) {
    if (i18n.language !== locale) await i18n.changeLanguage(locale);
    return i18n;
  }
  await i18n.use(initReactI18next).init({
    lng: locale,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: [...SUPPORTED_LOCALES],
    defaultNS: "common",
    ns: ["common"],
    resources: {
      "en-US": { common: enUS },
      "tr-TR": { common: trTR },
    },
    interpolation: {
      // React already escapes — i18next double-escape causes mojibake.
      escapeValue: false,
    },
    returnEmptyString: false,
    returnNull: false,
  });
  return i18n;
}

export { i18n };
export default i18n;
